module.exports = __webpack_public_path__ + "media/images/gfx/groups_xs-214edb345840b34fb82857ae698f752f.gif";